module.exports = __webpack_public_path__ + "media/ding.f15f546b.mp3";